import { useSelector, useDispatch } from 'react-redux';
import { setSliceScriptPasteText } from '../../../redux/slices/FJSliceTextToVideo';
import FJTextToVideoScriptPaste from './FJTextToVideoScriptPaste';
import FJActionTextToVideo from '../../../redux/action/FJActionTextToVideo';
import useLocalStore from '../../../hooks/useLocalStore';
import { useCallback } from 'react';

const FJTextToVideoScriptPasteContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const scriptPasteText = useSelector(state => state.textToVideo.scriptPasteText);
    const _onChange = useCallback(
        value => {
            dispatch(setSliceScriptPasteText(value));
        },
        [dispatch],
    );
    const onPasteNext = useCallback(() => {
        dispatch(FJActionTextToVideo.onPasteToScriptEditAction());
    }, [dispatch]);

    return (
        <FJTextToVideoScriptPaste scriptPasteText={scriptPasteText} onChange={_onChange} onPasteNext={onPasteNext} />
    );
};

export default FJTextToVideoScriptPasteContainer;
